/**
 * Generic Onboarding Page (Desktop)
 *
 * Unified onboarding screen that dynamically renders the appropriate form
 * based on URL parameter. Replaces 6 individual onboarding pages.
 *
 * Route: /onboarding/:category
 * - category: profile | assets | liabilities | income | expenses | assumptions
 */

import { Navigate } from "react-router-dom";
import { CelebrationScreen } from "../components/CelebrationScreen";
import { OnboardingModalLayout } from "../components/OnboardingModalLayout";
import { useOnboardingPageLogic } from "./OnboardingPage.logic";

function OnboardingPageWeb() {
  const {
    isValidCategory,
    FormComponent,
    categoryLabel,
    profileComplete,
    missingFields,
    nextDisabled,
    stepMetadata,
    handleSkip,
    nav,
  } = useOnboardingPageLogic();

  // Show celebration overlay after completing onboarding
  if (nav.showCelebration) {
    return <CelebrationScreen />;
  }

  // Validate category parameter and redirect if invalid
  if (!isValidCategory) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <OnboardingModalLayout
      currentIndex={nav.currentIndex}
      totalScreens={nav.totalScreens}
      categoryName={categoryLabel}
      headline={stepMetadata?.headline}
      description={stepMetadata?.description}
      tooltipContent={stepMetadata?.tooltipContent}
      tooltipAriaLabel={stepMetadata?.tooltipAriaLabel}
      contextCalloutText={stepMetadata?.contextCalloutText}
      onSkip={handleSkip}
      hasPrevious={nav.hasPrevious}
      hasNext={nav.hasNext}
      showDone={nav.showDone}
      onPrevious={nav.handlePrevious}
      onNext={nav.handleNext}
      onDone={nav.handleDone}
      canComplete={profileComplete && !nav.isTransitioning}
      missingFields={missingFields}
      nextDisabled={nextDisabled}
    >
      <FormComponent />
    </OnboardingModalLayout>
  );
}

export default OnboardingPageWeb;
